export const CreditCardEye = ({ size = "16" }: { size?: string }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_80_2566)">
      <path
        d="M4.56724 8.53353C5.11924 8.53353 5.56724 8.98153 5.56724 9.53353C5.56724 10.0855 5.11924 10.5335 4.56724 10.5335C4.01524 10.5335 3.56724 10.0855 3.56724 9.53353C3.56724 8.98153 4.01524 8.53353 4.56724 8.53353ZM16.6399 13.6922C16.0746 14.5042 14.7939 15.8669 12.5672 15.8669C10.3406 15.8669 9.05924 14.5042 8.4939 13.6922C8.14524 13.1909 8.14524 12.5429 8.4939 12.0415C9.05924 11.2295 10.3399 9.86686 12.5672 9.86686C14.7946 9.86686 16.0759 11.2289 16.6406 12.0415C16.9892 12.5429 16.9886 13.1915 16.6406 13.6922H16.6399ZM15.5452 12.8035C15.0366 12.0722 14.1072 11.2009 12.5666 11.2009C11.0259 11.2009 10.0966 12.0729 9.5879 12.8042C9.55924 12.8449 9.55924 12.8909 9.5879 12.9309C10.0972 13.6629 11.0266 14.5342 12.5672 14.5342C14.1079 14.5342 15.0372 13.6622 15.5459 12.9309C15.5746 12.8902 15.5746 12.8442 15.5459 12.8035H15.5452ZM6.8999 12.5342C6.8999 12.9022 6.60124 13.2009 6.23324 13.2009H4.23324C2.39524 13.2009 0.899902 11.7055 0.899902 9.86753V4.53353C0.900569 2.69553 2.3959 1.2002 4.2339 1.2002H13.5672C15.4052 1.2002 16.9006 2.69553 16.9006 4.53353V9.2002C16.9006 9.5682 16.6026 9.86686 16.2339 9.86686C15.8652 9.86686 15.5672 9.5682 15.5672 9.2002V5.86686H2.2339V9.86686C2.2339 10.9695 3.13124 11.8669 4.2339 11.8669H6.2339C6.6019 11.8669 6.90057 12.1655 6.90057 12.5335L6.8999 12.5342ZM2.2339 4.53353H15.5672C15.5672 3.43086 14.6699 2.53353 13.5672 2.53353H4.2339C3.13124 2.53353 2.2339 3.43086 2.2339 4.53353ZM12.5672 11.8669C12.0146 11.8669 11.5672 12.3142 11.5672 12.8669C11.5672 13.4195 12.0146 13.8669 12.5672 13.8669C13.1199 13.8669 13.5672 13.4195 13.5672 12.8669C13.5672 12.3142 13.1199 11.8669 12.5672 11.8669Z"
        fill="#706A85"
      />
    </g>
    <defs>
      <clipPath id="clip0_80_2566">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0.899902 0.400391)"
        />
      </clipPath>
    </defs>
  </svg>
);
